import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Card, IconDrag, Divider, Space } from '@redlink/components/atoms';

export const ListItemContainer = memo(
  ({
    children,
    StartComponent,
    EndComponent,
    FooterComponent,
    dragable,
    dragHandle,
    variant,
  }) => {
    const { styles } = useStyle();
    return (
      <Card
        style={[styles.container, variant && styles[`${variant}Container`]]}
      >
        <View style={styles.rootContainer}>
          <View style={styles.bodyMainContainer}>
            {dragable && (
              <>
                <div {...dragHandle}>
                  <IconDrag />
                </div>
                <Space size={15} />
              </>
            )}
            <View style={styles.bodyContainer}>{children}</View>
            <Space size={24} />
            {StartComponent && (
              <>
                <Divider horizontal={false} style={styles.divider} />
                <Space size={24} />
                {StartComponent}
              </>
            )}
          </View>
          <Space size={40} />
          <View style={styles.actionsContainer}>{EndComponent}</View>
        </View>
        {FooterComponent}
      </Card>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow }) => ({
  container: {
    flex:1,
    paddingVertical: 16,
  },
  minimalContainer: {
    flex:1,
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: 16,
    borderColor: colors.black3,
    ...shadow.none
  },
  rootContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bodyMainContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  bodyContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  divider: {
    height: 47,
  },
}));
